import { enableMapSet } from 'immer';
import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer, { SnackbarState } from './snackbar/snackbarSlice';
import { TypedUseSelectorHook, useSelector as rawUseSelector } from 'react-redux';
import dialogReducer, { DialogState } from './dialog/dialogSlice';
import layoutEditorReducer, {
  LayoutEditorState,
} from './layout-editor/layoutEditorSlice';

import dynamicTimeTableEditorReducer, {
  DynamicTimeTableEditorState,
} from './dynamic-timetable/dynamicTimeTableEditorSlice';

enableMapSet();
const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    dialog: dialogReducer,
    layoutEditor: layoutEditorReducer,
    dynamicTimeTableEditor: dynamicTimeTableEditorReducer,
  },
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export interface AppState {
  snackbar: SnackbarState;
  dialog: DialogState;
  layoutEditor: LayoutEditorState;
  dynamicTimeTableEditor: DynamicTimeTableEditorState;
}

export default store;
export type AppDispatch = typeof store.dispatch;
export const useSelector: TypedUseSelectorHook<AppState> = rawUseSelector;
